import React from 'react';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

export interface OwnershipStatusIndicatorProps {
  isConfirmed: boolean;
}

export const OwnershipStatusIndicator = ({
  isConfirmed,
}: Readonly<OwnershipStatusIndicatorProps>) => {
  return isConfirmed ? (
    <CheckCircleIcon style={{ color: '#2e7d32' }} />
  ) : (
    <WarningIcon style={{ color: '#ed6c02' }} />
  );
};
